import React from "react";

export default function MusicHero({ query, onQueryChange, onSearch }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query);
  };

  return (
    <header className="music-hero">
      <div className="container text-center">
        <div className="mu-eyebrow on-purple">The Music Library</div>
        <h1>Discover the Sound of Now</h1>
        <p>
          Browse new releases, search by artist, title, genre, or tag, and stream the tracks
          shaping the culture right now.
        </p>
        <form className="music-search-bar" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Search by title, artist, genre, or tag..."
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
          />
          <button type="submit">Search</button>
        </form>
        <a href="#submit-music" className="btn-mu-solid mt-4 d-inline-block">Submit Your Music &rarr;</a>
      </div>
    </header>
  );
}
